import { createSlice } from "@reduxjs/toolkit";
import initialValues from "./initialValues";
import initialState from "./initialValues";

const userSlice = createSlice({
  name: "user",
  initialState,

  reducers: {
    loggedUser(state, action) {
      state.user = { ...state.user, ...action.payload };
    },
    logout(state, action) {
      state.user = initialValues.user;
      state.cart = initialValues.cart;
    },
    saveProductList(state, action) {
      state.products = action.payload;
    },
    addItemToCart(state, action) {
      const productInCart = state.cart.find(
        (product) => product.name === action.payload.name
      );
      if (productInCart) {
        productInCart.qty = productInCart.qty + action.payload.qty;
      } else {
        state.cart.push(action.payload);
      }
    },
    removeItemFromCart(state, action) {
      state.cart = state.cart.filter(
        (product) => product.name !== action.payload.name
      );
    },
    removeOneFromCart(state, action) {
      const productInCart = state.cart.find(
        (product) => product.name === action.payload.name
      );
      productInCart.qty = productInCart.qty - 1;
    },

    flushCart(state, action) {
      state.cart = initialState.cart;
    },
    addOrderToUser(state, action) {
      state.user.lastOrder = action.payload;
    },
  },
});

const { actions, reducer } = userSlice;
export const {
  loggedUser,
  logout,
  saveProductList,
  addItemToCart,
  removeItemFromCart,
  removeOneFromCart,
  flushCart,
  addOrderToUser,
} = actions;
export default reducer;
